import { useCallback, useEffect, useState } from 'react';
import {
    ALEGARTA_SMOKE_CHANGE_EVENT,
    ALEGARTA_SMOKE_STORAGE_KEY,
    readAlegartaSmokeEnabled,
    writeAlegartaSmokeEnabled,
} from '../utils/alegartaBackgroundPreference';

/**
 * Per-user opt-in for the animated Alegarta background (localStorage, default off).
 */
export function useAlegartaSmokeEnabled() {
    const [enabled, setEnabled] = useState(() => readAlegartaSmokeEnabled());

    useEffect(() => {
        const onChange = (event) => {
            if (typeof event.detail === 'boolean') {
                setEnabled(event.detail);
            } else {
                setEnabled(readAlegartaSmokeEnabled());
            }
        };

        const onStorage = (event) => {
            if (event.key === null || event.key === ALEGARTA_SMOKE_STORAGE_KEY) {
                setEnabled(readAlegartaSmokeEnabled());
            }
        };

        window.addEventListener(ALEGARTA_SMOKE_CHANGE_EVENT, onChange);
        window.addEventListener('storage', onStorage);
        return () => {
            window.removeEventListener(ALEGARTA_SMOKE_CHANGE_EVENT, onChange);
            window.removeEventListener('storage', onStorage);
        };
    }, []);

    const setSmokeEnabled = useCallback((next) => {
        const value = writeAlegartaSmokeEnabled(next);
        setEnabled(value);
    }, []);

    return [enabled, setSmokeEnabled];
}
